export type RunStatusTone = 'success' | 'skipped' | 'failed'

export function getRunStatusTone(status: string): RunStatusTone {
  if (status === 'completed') return 'success'
  if (status.startsWith('skipped')) return 'skipped'
  return 'failed'
}
